<template>
    <div>
        <div class="text-center text-muted d-flex flex-column justify-content-center align-items-center" style="height: 521px;">
            <i class="bi bi-exclamation-circle-fill" style="font-size: 2rem;"></i>
            <template v-if="loading">
                <b-spinner></b-spinner>
                <h6 class="mt-3 gray-400">{{loadingText}}</h6>
            </template>
            <template v-else>
                <h6 class="mt-3 gray-400">{{text}}</h6>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageEmptyComponent',
    props: {
        text: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: ''
        }
    }
};
</script>
